import { TaskIssue, TaskPullRequest } from "./Task"
import { getAllAssignees } from "./TaskData"

/**
 * Instantiates TaskIssue instances for an Issue task in the raw data contents for each group member assigned to Issue
 * @param {Object} rawTaskData - raw Issue task data of the org project contents array fetched from GitHub GraphQL API
 * @param {string} kanbanStatus - Kanban board status of the task Pull Request: In Progress, Done, etc.
 * @param {[string]} assignees - array of usernames belonging to the group members assigned to the Issue
 * @returns {*[TaskIssue]} array of TaskIssue instance objects for each assigned group member for each task
 */
const instantiateTaskIssues = (rawTaskData, kanbanStatus, assignees) => {
    const
        taskIssues = [],
        labels = [];

    for (let labelData in rawTaskData["content"]["labels"]["nodes"]) {
        labels.push(rawTaskData["content"]["labels"]["nodes"][labelData]["name"]);
    }

    assignees = getAllAssignees(assignees);
    for (let assignee in assignees) {
        taskIssues.push(
            new TaskIssue(
                rawTaskData["content"]["number"],
                rawTaskData["content"]["title"],
                rawTaskData["content"]["body"],
                rawTaskData["content"]["createdAt"],
                rawTaskData["content"]["closedAt"],
                kanbanStatus,
                rawTaskData["content"]["url"],
                rawTaskData["content"]["comments"]["nodes"],
                assignees[assignee],
                Array.from(assignees),
                rawTaskData["content"]["milestone"],
                labels
            )
        )
    }
    return taskIssues;
}

/**
 * Instantiates a TaskPullRequest instance for a Pull Request task in the raw data contents for all assigned members
 * @param {Object} rawTaskData - raw Pull Request task data of the org project contents array fetched from GitHub API
 * @param {string} kanbanStatus - Kanban board status of the task Pull Request: In Review, Done, etc.
 * @param {[string]} assignees - array of usernames belonging to the group members assigned to the Pull Request
 * @returns {TaskPullRequest} a TaskPullRequest instance object
 */
const instantiateTaskPullRequest = (rawTaskData, kanbanStatus, assignees) => {
    const
        reviewers = new Set(),
        issueUrls = [];

    for (let reviewerData in rawTaskData["content"]["reviews"]["nodes"]) {
        reviewers.add(rawTaskData["content"]["reviews"]["nodes"][reviewerData]["author"]["login"]);
    }

    for (let issueUrlsData in rawTaskData["content"]["closingIssuesReferences"]["edges"]) {
        issueUrls.push(rawTaskData["content"]["closingIssuesReferences"]["edges"][issueUrlsData]["node"]["url"]);
    }

    return new TaskPullRequest(
        rawTaskData["content"]["number"],
        rawTaskData["content"]["title"],
        rawTaskData["content"]["body"],
        rawTaskData["content"]["createdAt"],
        rawTaskData["content"]["closedAt"],
        kanbanStatus,
        rawTaskData["content"]["url"],
        rawTaskData["content"]["comments"]["nodes"],
        assignees,
        Array.from(reviewers),
        issueUrls
    );
}

export { instantiateTaskIssues, instantiateTaskPullRequest };
